import { useMemo } from 'react';
import { ApplicationListActiveFilters } from 'components/ApplicationListActiveFilters/ApplicationListActiveFilters';

/**
 * Active filter chip strip + count for ui-kit Table (`dropFilterActiveSummary` / `dropFilterActiveCount`).
 *
 * @param {Array<{ id: string, label: string }>} chips
 * @param {(chipId: string) => void} onRemoveChip
 * @param {() => void} onClearAll
 */
export function useDropFilterActiveSummaryBar(chips, onRemoveChip, onClearAll) {
  return useMemo(() => {
    const count = Array.isArray(chips) ? chips.length : 0;
    if (!count) {
      return { dropFilterActiveSummary: null, dropFilterActiveCount: 0 };
    }
    return {
      dropFilterActiveSummary: (
        <ApplicationListActiveFilters
          chips={chips}
          onRemoveChip={onRemoveChip}
          onClearAll={onClearAll}
        />
      ),
      dropFilterActiveCount: count,
    };
  }, [chips, onRemoveChip, onClearAll]);
}
